import UserDatabases from '@Services/UserDatabases';

export default function useSupportsReactions(params) {
  const { databaseId } = params;
  return UserDatabases.supportsReaction(databaseId);
}
